import { render } from "./GoiY.vue?vue&type=template&id=6dc975c3&scoped=true"
import script from "./GoiY.vue?vue&type=script&lang=js"
export * from "./GoiY.vue?vue&type=script&lang=js"

import "./GoiY.vue?vue&type=style&index=0&id=6dc975c3&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc975c3"]])

export default __exports__